import { render, staticRenderFns } from "./addLeads.vue?vue&type=template&id=ba951a02&scoped=true&"
import script from "./addLeads.vue?vue&type=script&lang=js&"
export * from "./addLeads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba951a02",
  null
  
)

export default component.exports